import React from 'react'
import axios from 'axios'
import Select from 'react-select'
import { isEqual } from 'lodash'
import { fnum } from '../../utils/utils'
import { servAddr } from '../../servAddr'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import { sortOpts } from '../../utils/utils'

export default class FileItem extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      data: props.file,
      delConf: false,
      errors: {},
      edit: false
    };
  }

  saveFile = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(this.props.file, data)) {
      this.cancelEdit();
    }
    else {
      this.props.editFile(data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.setState({
          errors: {},
          edit:false
        });
      });
    }
  }

  deleteFile = e => {
    e.preventDefault();
    this.props.editFile({
      ...this.props.file,
      file_active: 0
    }, err => {
      if (err) {
        this.setState({errors: err});
        return;
      }
      this.setState({
        errors: {},
        edit:false
      });
    });
  }

  onclick = e => {
    e.preventDefault();
    this.setState({edit:true});
  }

  cancelEdit = () => {
    this.setState({edit:false});
  }

  downloadFile = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({errors: {}});
    const { order: { order_id }, file: { file_id, file_desc, file_extension } } = this.props;
    axios({
      method: 'get',
      url: servAddr + 'file?order_id=' + order_id + '&file_id=' + file_id,
      responseType: 'arraybuffer'
    }).then(response => {
      let blob = new Blob([response.data]);
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = file_desc + '.' + file_extension;
      link.click();
    }, (err) => {
      this.setState({
        errors: err.response.data.errors || {form: "Ошибка " + err.response.status}
      });
    });
  }

  updateInput = e => {
    this.setState({
      data:{
        ...this.state.data,
        [e.target.name]: e.target.value
      }
    });
  }

  updateFiletype = e => {
    this.setState({
      data: {
        ...this.state.data,
        file_filetype_id: e.value
      }
    });
  }

  toggleDelConf = () => {
    const delConf = !this.state.delConf;
    this.setState({delConf:delConf});
  }

  render() {

    const { edit, data, errors } = this.state;
    const { file, filetypes } = this.props;

    const filetypesOpt = [];
    for (let key in filetypes){
      if(filetypes.hasOwnProperty(key) && (filetypes[key].filetype_active === 1
        || filetypes[key].filetype_id === data.file_filetype_id)) {
        filetypesOpt.push({value:filetypes[key].filetype_id,label:filetypes[key].filetype_desc});
      }
    }
    filetypesOpt.sort(sortOpts);

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteFile}
        onCancel={this.toggleDelConf}
      />
      :
      '';
    if (edit){
      return (
        <tr>
          <td>
            {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={data.file_desc}
                placeholder="Название файла"
                name="file_desc"
                onChange={this.updateInput}
              />
            </div>
            <button  type="button" className="btn btn-success btn-sm"
              onClick={this.saveFile} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default btn-sm"
              onClick={this.cancelEdit} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>{" "}
            <button type="button" className="btn btn-danger btn-sm"
              onClick={this.toggleDelConf} title="Удалить">
              <span className="glyphicon glyphicon-trash"></span>
            </button>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <Select
              clearable={false}
              options={filetypesOpt}
              value={data.file_filetype_id}
              onChange={this.updateFiletype}
              placeholder="Тип файла"
            />
          </td>
          <td>{file.file_date}</td>
          <td className="text-right">{fnum(file.file_size/1024)}</td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={data.file_note}
                placeholder="Заметка"
                name="file_note"
                onChange={this.updateInput}
              />
            </div>
          </td>
        </tr>
      );
    }
    else{
      const filtypeDesc = filetypes[file.file_filetype_id] ?
        filetypes[file.file_filetype_id].filetype_desc : '';
      const filetypeColor = filetypes[file.file_filetype_id] ?
        filetypes[file.file_filetype_id].filetype_color : 'transparent';
      return (
        <tr className="show-hover-container" onClick={this.onclick}>
          <td>
            <button type="button" className="btn btn-info btn-xs show-hover"
              onClick={this.downloadFile}>
              Скачать
            </button>{" "+file.file_desc+"."+file.file_extension}
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <span
              className="glyphicon glyphicon-tag"
              style={{color: filetypeColor}}
            />{" "}
            {filtypeDesc}
          </td>
          <td>
            <span title={file.file_date.slice(10)}>
              {file.file_date.slice(0, 10)}
            </span>
          </td>
          <td className="text-right">{fnum(file.file_size/1024)}</td>
          <td>{file.file_note}</td>
        </tr>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/order/FileItem.js